import { render, staticRenderFns } from "./RadioProp.vue?vue&type=template&id=e456528c&"
import script from "./RadioProp.vue?vue&type=script&lang=js&"
export * from "./RadioProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports